/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{resolveIncludes as t}from"./sources/resolver.js";const r={vertexShader:t("bitBlit/bitBlit.vert"),fragmentShader:t("bitBlit/bitBlit.frag")};export{r as bitBlit};
